/* ---------------------------------------------------------------------------------------------------------------------
    CUSTOM DELEGATE EXTENSION
   ------------------------------------------------------------------------------------------------------------------ */
HTMLElement.prototype.customDelegate = function customDelegate(
  eventName,
  elementSelector,
  handler
) {
  this.addEventListener(
    eventName,
    (e) => {
      const element = e.target.closest(elementSelector);

      if (element) {
        handler.call(element, e, element);
      }
    },
    false
  );
};

HTMLElement.prototype.removeCustomDelegate = function removeCustomDelegate(
  eventName,
  elementSelector,
  handler
) {
  this.removeEventListener(
    eventName,
    (e) => {
      const element = e.target.closest(elementSelector);

      if (element) {
        handler.call(element, e, element);
      }
    },
    false
  );
};

/* ---------------------------------------------------------------------------------------------------------------------
    DEBOUNCE EXTENSION
   ------------------------------------------------------------------------------------------------------------------ */
Function.prototype.debounce = function (delay) {
  let timeoutId;
  const func = this;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

/* ---------------------------------------------------------------------------------------------------------------------
    FOCUS TRAP EXTENSION
   ------------------------------------------------------------------------------------------------------------------ */
HTMLElement.prototype.getFocusableElements = function () {
  return Array.from(
    this.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"]), [role="button"], [role="checkbox"], [role="link"], [role="radio"], [role="textbox"]'
    )
  );
};

HTMLElement.prototype.trapFocus = function () {
  const focusableElements = this.getFocusableElements();

  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  this.addEventListener('keydown', function (event) {
    if (event.shiftKey && document.activeElement === firstFocusableElement) {
      // Shift + Tab is pressed, move focus to the last focusable element
      event.preventDefault();
      lastFocusableElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      // Tab is pressed, move focus to the first focusable element
      event.preventDefault();
      firstFocusableElement.focus();
    }
  });
};

HTMLElement.prototype.removeTrapFocus = function () {
  this.removeEventListener('keydown', this.trapFocus);
};

/* ---------------------------------------------------------------------------------------------------------------------
    WAIT FOR ELEMENT EXTENSION
   ------------------------------------------------------------------------------------------------------------------ */
HTMLElement.prototype.waitForElementVisibility = function () {
  return new Promise((resolve, reject) => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          resolve();
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(this);
  });
};

/* -----------------------------
    CACHED FETCH
   ----------------------------- */

window.cachedResponses = new Map();

window.cachedFetch = async function (url, immediate = true, delay = 500) {
  if (cachedResponses.has(url)) {
    if (!immediate) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }

    return Promise.resolve(cachedResponses.get(url));
  }

  const networkResponse = await fetch(url);

  if (networkResponse.ok) {
    const contentType = networkResponse.headers.get("content-type");

    if (contentType.includes("application/json")) {
      const responseBody = await networkResponse.json();
      cachedResponses.set(url, responseBody);

      return Promise.resolve(responseBody);
    } else if (contentType.includes("text")) {
      const textResponse = await networkResponse.text();
      cachedResponses.set(url, textResponse);

      return Promise.resolve(textResponse);
    } else {
      const blobResponse = await networkResponse.blob();
      return Promise.resolve(blobResponse);
    }
  }

  return Promise.resolve(networkResponse);
}
